import { useState } from "react";
import moment from "moment";
moment.locale("es");

export const useCRMUpdateUuid = () => {
    const [form, setForm] = useState({});
    const [isValid, setIsValid] = useState(false);
    const [error, setError] = useState("");

    const storeData = async (data) => {
        let f = {
            uuid: data["uuid"],
            reference_uuid: data["reference_uuid"] || "",
            customer_uuid: data["customer_uuid"] || ""
        };
        setForm(JSON.parse(JSON.stringify(f)));
    };

    const onHandleChange = (key1, e) => {
        let f = form;
        let value = e["target"]["value"].trim();

        f[key1] = value;

        validateForm(f);
        setForm(JSON.parse(JSON.stringify(f)));
    };

    const validateForm = (f) => {
        if (f["reference_uuid"]) {
            setIsValid(true);
            setError("");
        } else {
            setIsValid(false);
            setError("Identificador no válido.");
        }
    };

    const getPayload = () => {
        const payload: any = {
            uuid: form["uuid"],
            reference_uuid: form["reference_uuid"]
        };
        if (form["customer_uuid"]) {
            payload["customer_uuid"] = form["customer_uuid"];
        }
        return payload;
    };

    return {
        form,
        isValid,
        error,
        storeData,
        onHandleChange,
        getPayload
    };
};
